import { CSSProperties } from "react";

export const SkippedOrdersIcon = (style?: CSSProperties) => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M5.94336 6.0127C6.56499 6.0127 7.09323 6.23004 7.52832 6.66504C7.96345 7.10017 8.18164 7.62828 8.18164 8.25C8.18164 8.87172 7.96345 9.39983 7.52832 9.83496C7.09323 10.27 6.56499 10.4873 5.94336 10.4873C5.32181 10.4872 4.79344 10.27 4.3584 9.83496C3.9234 9.39987 3.70605 8.87163 3.70605 8.25C3.70605 7.62837 3.9234 7.10013 4.3584 6.66504C4.79344 6.23 5.32181 6.01279 5.94336 6.0127ZM11.9316 0.0126953V5.2373H6.70605V3.7627H9.86523L9.85449 3.74316C9.4535 3.06662 8.91125 2.52186 8.22852 2.1084C7.54521 1.69465 6.78302 1.4873 5.94336 1.4873C4.84055 1.48739 3.86896 1.84523 3.0293 2.55957C2.1925 3.27156 1.68588 4.16425 1.50879 5.2373H0.0146484C0.191744 3.75918 0.838918 2.51956 1.95801 1.51855C3.08064 0.514421 4.40293 0.0127383 5.9248 0.0126953C6.83557 0.0126953 7.67795 0.196551 8.45117 0.564453C9.2245 0.93245 9.8858 1.43425 10.4346 2.07031L10.4561 2.0957V0.0126953H11.9316Z"
      fill="#FFE2AB"
      stroke="#8ACEFF"
      strokeWidth="0.025"
    />
  </svg>
);

export const SnowLevelIcon = (style?: CSSProperties) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M21.09 13.95L18.76 14.57L16.76 13.44V10.56L18.76 9.43L21.09 10.05L21.61 8.12L19.84 7.65L20.3 5.88L18.37 5.36L17.75 7.69L15.75 8.82L13.3 7.38V5.12L15.01 3.41L13.59 2L12.3 3.29L11.01 2L9.59 3.41L11.3 5.12V7.38L8.8 8.82L6.8 7.69L6.22 5.36L4.3 5.88L4.77 7.65L3 8.12L3.52 10.05L5.85 9.43L7.85 10.56V13.45L5.85 14.58L3.52 13.96L3 15.89L4.77 16.36L4.3 18.12L6.23 18.64L6.85 16.31L8.85 15.18L11.3 16.62V18.88L9.59 20.59L11.01 22L12.3 20.71L13.59 22L15 20.59L13.3 18.88V16.62L15.8 15.17L17.8 16.3L18.42 18.63L20.3 18.12L19.83 16.35L21.6 15.88L21.09 13.95ZM9.8 10.56L12.3 9.11L14.8 10.56V13.44L12.3 14.89L9.8 13.44V10.56Z"
      fill="#FFE2AB"
    />
  </svg>
);
